import React from 'react';
import PropTypes from 'prop-types';
import linkHelper from '../../../../helpers/linkHelper';


const ClickableImageTemplate = function ClickableImageTemplateComponent({
  image,
  linkTo,
  external,
  imageAltText,
  title,
  subtitle,
  buttonText,
}) {
  const externalMeta = '{openNewTab}';
  const parsedLinkTo = `${linkTo}${external && !linkTo.includes(externalMeta) ? externalMeta : ''}`;
  const { href, openNewTab } = linkHelper(parsedLinkTo);

  return (
    <>
      <h1 className="slot-homepage-hero__hidden-text">{title}</h1>
      <h2 className="slot-homepage-hero__hidden-text">{subtitle}</h2>
      <div className="slot-homepage-hero__hidden-text" id="slot_homepage_hero_link_descriptor">
        {`Go to ${buttonText}`}
      </div>
      <a
        className="slot-homepage-hero__clickable-banner"
        href={href}
        target={openNewTab ? '_blank' : '_self'}
        aria-labelledby="slot_homepage_hero_link_descriptor"
      >
        <img src={image} alt={imageAltText} className="slot-homepage-hero__image" />
      </a>
    </>
  );
};

ClickableImageTemplate.propTypes = {
  image: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired,
  external: PropTypes.bool,
  imageAltText: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};

ClickableImageTemplate.defaultProps = {
  external: false,
  imageAltText: '',
};

export default ClickableImageTemplate;
